import { RefreshCw } from "lucide-react";
import { QR } from "@/constants/testIds";

export const RefreshIndicator = ({ loading, onRefresh, lastLoaded }) => (
  <button onClick={onRefresh} disabled={loading} data-testid={QR.refreshNow}
    className="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-600 hover:border-slate-300 hover:text-brand transition-colors disabled:opacity-60">
    <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
    <span>Segarkan</span>
    {lastLoaded && <span className="text-xs text-slate-400 tabular-nums" data-testid={QR.refreshIndicator}>{lastLoaded}</span>}
  </button>
);
